import React, { useEffect } from 'react'

import { useParams } from 'react-router-dom'

import { useAppSelector } from 'src/Hooks/redux'
import { getCampaignToSchedule } from 'src/Redux/campaign-process/spotifyCampaignSchedule-process/selectors'
import {
  GenreWithCurators,
  useGetCampaignGenresQuery,
} from 'src/Redux/spotifyCampaignGenresApi'

type UseSelectedGenresReturnType = {
  selectedGenres: GenreWithCurators[]
  onSetSelectedGenres: (genre: GenreWithCurators) => void
}
export const useSelectedGenres = (): UseSelectedGenresReturnType => {
  const campaignDetails = useAppSelector(getCampaignToSchedule)
  const [selectedGenres, setSelectedGenres] = React.useState<
    GenreWithCurators[]
  >([])
  const { number } = useParams<{ number: string }>()
  const { data, isSuccess } = useGetCampaignGenresQuery(number || '', {
    skip: !number,
  })
  const handleSelectedGenres = (genre: GenreWithCurators): void => {
    setSelectedGenres((prev) => {
      const isGenreSelected = prev.some((item) => item.id === genre.id)
      if (isGenreSelected) {
        return prev.filter((item) => item.id !== genre.id)
      }
      return [...prev, genre]
    })
  }

  useEffect(() => {
    if (campaignDetails.genres?.length && isSuccess) {
      const campaignRelatedGenres =
        data?.allGenres?.filter((genre) =>
          campaignDetails.genres?.some((item) => item.id === genre.id),
        ) || []
      setSelectedGenres(campaignRelatedGenres)
    }
  }, [campaignDetails.genres, data?.allGenres, isSuccess])

  return { selectedGenres, onSetSelectedGenres: handleSelectedGenres }
}
